import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../contexts/authContext/index.jsx";
import MainTabs from "../partials/main-tabs.jsx";
import { useParams } from "react-router-dom";
import { deleteRecord, viewRecord } from "../../firebase/db/fans/crud.tsx";
import { useNavigate } from "react-router-dom";

interface FanData {
	id: string;
	email: string;
	first_name: string;
	last_name: string;
	mobile: string;
}

const FanView = () => {
	const { currentUser } = useAuth();
	const navigate = useNavigate();
	const { id } = useParams();
	const [data, setData] = useState<FanData | null>(null);
	const [createdDate, setCreatedDate] = useState(String);
	const [modifiedDate, setModifiedDate] = useState(String);
	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	const [formData, setFormData] = useState({
		first_name: "",
		last_name: "",
		email: "",
		mobile: "",
		country: "",
		state: "",
		user: ""
	});
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	function handleDeleteRecord(recordId) {
		deleteRecord(recordId);
	}

	useEffect(() => {
		const fetchDataAndSetState = async () => {
			try {
				console.log("Fetching data...");
				const fetchedData = await viewRecord(id);
				if (fetchedData !== null) {
					setCreatedDate(getFormattedDate(fetchedData?.created));
					setModifiedDate(getFormattedDate(fetchedData?.modified));
					setData(fetchedData);
				} else {
					setData(null);
				}
			} catch (e) {
				setError(e); //More informative error message
			} finally {
				setIsLoading(false);
			}
		};

		fetchDataAndSetState();
	}, [id]);

	function getFormattedDate(date) {
		if (date) {
			return (
				date.toDate().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) + " " + date.toDate().toLocaleDateString("en-US")
			);
		} else {
			return "";
		}
	}

	if (isLoading) {
		return (
			<div className="text-center">
				<div role="status">
					<svg
						aria-hidden="true"
						className="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
						viewBox="0 0 100 101"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
							fill="currentColor"
						/>
						<path
							d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
							fill="currentFill"
						/>
					</svg>
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		);
	}

	if (error) {
		return <div>Error: {error}</div>;
	}

	return (
		<div className="main-tabs">
			<div className="mx-auto">
				<MainTabs tabIndexSelected={1} />
				<div id="myTabContent">
					<div className="flex justify-between w-full page-header">
						<div className="page-heading">
							<img src="../../../assets/icons/fan-icon.png" alt="Fans" className="icon-large" />
							<div className="text-xs font-bold dark:text-white">
								<span className="mb-0 text-transparent bg-clip-text bg-gradient-to-r to-fuchsia-700 from-violet-700">FAN</span>
								<br />
								<div className="mt-0 text-3xl font-medium dark:text-white">
									{data.first_name} {data.last_name}
								</div>
							</div>
						</div>
					</div>
					<div className="grid grid-cols-4 gap-5">
						<div
							className="col-span-3 shadow-xl bg-slate-500 p-4 rounded-lg tabpanel"
							id="profile"
							role="tabpanel"
							aria-labelledby="profile-tab">
							<div className="mb-2 flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4">
								<div>
									<h2 className="text-3xl font-medium">Detail</h2>
								</div>
								<div className="relative">
									<div className="inline-flex rounded-md shadow-xs" role="group">
										<button
											onClick={() => navigate(`/fans/edit/${id}`)}
											type="button"
											className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
											Edit
										</button>
										<button
											onClick={() => navigate(`/fans`)}
											type="button"
											className="px-4 py-2 text-sm font-light text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
											Close
										</button>
										<button
											onClick={() => handleDeleteRecord(id)}
											type="button"
											className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
											Delete
										</button>
									</div>
								</div>
							</div>
							<form onChange={handleChange} className="">
								<div className="flex gap-8">
									<div className="flex-auto">
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="first_name"
													id="first_name"
													value={data.first_name}
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													disabled
												/>
												<label
													for="first_name"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													First Name
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="last_name"
													id="last_name"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={data.last_name}
													disabled
												/>
												<label
													for="last_name"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Last Name
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="email"
													id="email"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={data.email}
													disabled
												/>
												<label
													for="email"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Email
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
													name="mobile"
													id="mobile"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={data.mobile}
													disabled
												/>
												{/* <PhoneInput
												name="mobile"
												id="mobile"
												className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
												placeholder="Enter phone number"
												value={value}
												onChange={setValue}
												defaultCountry="US"
											/> */}
												<label
													for="mobile"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Mobile
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="country"
													id="country"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={data.country}
													disabled
												/>
												<label
													for="country"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Country
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
													name="state"
													id="state"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={data.state}
													disabled
												/>
												<label
													for="state"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													State
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="created"
													id="created"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={createdDate}
													disabled
												/>
												<label
													for="created"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Created
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="modified"
													id="modified"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													value={modifiedDate}
													disabled
												/>
												<label
													for="modified"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Modified
												</label>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div
							className="shadow-xl bg-slate-500 p-4 pb-6 rounded-lg form-panel"
							id="profile"
							role="tabpanel"
							aria-labelledby="profile-tab">
							<div className="mb-2 flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-2">
								<div>
									<h2 className="text-3xl font-medium">Edit</h2>
								</div>
								<div className="relative">
									<div className="inline-flex rounded-md shadow-xs" role="group">
										<button
											onClick={() => navigate(`/fans/view/${id}`)}
											type="button"
											className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
											Cancel
										</button>
										<button
											onClick={() => handleEditRecord()}
											type="button"
											className="px-4 py-2 text-sm font-light text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
											Save
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FanView;
